import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../Redux Store/Slices/auth";
import { baseUrl } from "../utils/urls";

export function useSSEProfile() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const isSkipLogin = useSelector((s) => s.auth.isSkipLogin);
  const esRef = useRef(null);

  useEffect(() => {
    if (!isAuthenticated || isSkipLogin) return;

    const token = sessionStorage.getItem("access_token");
    if (!token) return;

    const url = `${baseUrl}api/advisor/advisor-profile-sse?token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);
    esRef.current = es;

    es.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data?.advisor_id) dispatch(setUserData(data));
      } catch {}
    };

    es.onerror = () => {
      es.close();
    };

    return () => {
      es.close();
    };
  }, [isAuthenticated, isSkipLogin, dispatch]);
}
